<template>
  <div class="section">
    <div class="section-header">{{ isHelpPage ? $t('COMMON.instructions') : $t('DASHBOARD.welcomePage.welcome') }}</div>
    <div class="section-content">
      <div v-if="user">
        <template>
          <div>
            <b-carousel
              id="carousel1"
              class="custom-carousel"
              controls
              indicators
              background="transparent"
              :interval="0"
              img-width="1024"
              img-height="350"
              v-model="slide"
              @sliding-start="onSlideStart"
              @sliding-end="onSlideEnd">
              <b-carousel-slide class="carousel-slide">
                <div class="item clearfix">
                  <div class="info w-100">
                    <h3 class="title orange-text-clr">{{ $t('DASHBOARD.welcomePage.slide_1.title')}}</h3>
                    <div class="row">
                      <div class="iframe-container col-lg-6 mb-5">
                      <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/MZAagcKvfMw" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div>
                    <div class="col-lg-6">
                      <p class="paragraph long-paragraph">{{ $t('DASHBOARD.welcomePage.slide_1.paragraph_1')}}</p>
                      <p class="paragraph long-paragraph">{{ $t('DASHBOARD.welcomePage.slide_1.paragraph_2')}}</p>
                      <p class="paragraph long-paragraph">{{ $t('DASHBOARD.welcomePage.slide_1.paragraph_3')}}</p>
                      <p class="paragraph long-paragraph">{{ $t('DASHBOARD.welcomePage.slide_1.paragraph_4')}}</p>
                    </div>
                    </div>
                  </div>
                </div>
              </b-carousel-slide>

              <b-carousel-slide class="carousel-slide">
                <div class="item clearfix">
                  <div class="info w-100">
                    <h3 class="title orange-text-clr">{{ $t('DASHBOARD.welcomePage.slide_2.title')}}</h3>
                    <div class="row">
                      <div class="iframe-container col-lg-6 mb-5">
                        <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/GijILvr7wUI" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                      </div>
                      <div class="col-lg-6">
                        <p class="paragraph long-paragraph">{{ $t('DASHBOARD.welcomePage.slide_2.paragraph_1')}}</p>
                        <p class="paragraph long-paragraph">{{ $t('DASHBOARD.welcomePage.slide_2.paragraph_2')}}</p>
                        <p class="paragraph long-paragraph">{{ $t('DASHBOARD.welcomePage.slide_2.paragraph_3')}}</p>
                        <p class="paragraph long-paragraph">{{ $t('DASHBOARD.welcomePage.slide_2.paragraph_4')}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </b-carousel-slide>

              <b-carousel-slide class="carousel-slide">
                <div class="item clearfix">
                  <div class="img-wrapper high-section">
                    <img src="@/assets/images/dashboard/suppy.png" alt="Suppy Social Media" class="img">
                  </div>
                  <div class="info">
                    <h3 class="title orange-text-clr">{{ $t('DASHBOARD.welcomePage.slide_3.title')}}</h3>
                    <i18n path="DASHBOARD.welcomePage.slide_3.paragraph_1" tag="p" class="paragraph">
                      <span slot="followUs" class="bold">{{ $t('DASHBOARD.welcomePage.slide_3.followUs')}}</span>
                    </i18n>
                    <div class="social-media-icons">
                      <div class="icon-wrapper">
                          <a href="https://www.facebook.com/beyondpulse/" target="_blank" rel="noopener">
                              <img src="@/assets/images/dashboard/facebook.png" alt="facebook">
                          </a>
                      </div>
                      <div class="icon-wrapper">
                        <a href="https://twitter.com/beyondpulse" target="_blank">
                            <img src="@/assets/images/dashboard/twitter.png" alt="twitter" rel="noopener">
                        </a>
                      </div>
                      <div class="icon-wrapper">
                          <a href="https://www.instagram.com/beyondpulse/" target="_blank" rel="noopener">
                              <img src="@/assets/images/dashboard/instagram.png" alt="instagram">
                          </a>
                      </div>
                      <div class="icon-wrapper">
                          <a href="https://www.youtube.com/channel/UCQrDaLWl_kmij7BZ5YGYQOQ" target="_blank" rel="noopener">
                              <img src="@/assets/images/dashboard/youtube.png" alt="youtube">
                          </a>
                      </div>
                    </div>
                    <p class="paragraph">{{ $t('DASHBOARD.welcomePage.slide_3.paragraph_2')}}</p>
                    <p class="paragraph short-paragraph">{{ $t('DASHBOARD.welcomePage.slide_3.paragraph_3')}}</p>
                  </div>
                </div>
              </b-carousel-slide>
            </b-carousel>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Welcome',
  props: {
    isHelpPage: Boolean
  },
  data () {
    return {
      resendInterval: null,
      slide: 0,
      sliding: null
    }
  },
  computed: {
    ...mapGetters(['user']),
    url: {
      get () {
        return this.user.parentId != null && this.user.playerDetails.length
          ? this.user.playerDetails[0].shopLink
          : this.user.shopLink
      }
    }
  },
  methods: {
    onSlideStart () {
      this.sliding = true
    },
    onSlideEnd () {
      this.sliding = false
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/scss/views/_dashboard.scss';

  .section-header {
    margin-bottom: 0;
  }
 
  .section-content {
    padding-top: 10px;
  }

  .iframe-container {
    width: 65%;
    position: relative;
    height: 0;
    overflow: hidden;
    padding-top: 36%;
      
      iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      max-width: 700px;
    }
  }

@media screen and (max-width: 992px) {
    .iframe-container {
    width: 100%;
    padding-top: 56.25%;
  }
}

</style>
